import { useEffect, useState } from "react";
import { HashLink } from "react-router-hash-link";
import { useHeadsObserver } from "../utils/useObserver";
import RelatedLink from "./RelatedLink";

function TableOfContent({ pageID }) {
  const [headings, setHeadings] = useState([]);
  const { activeId } = useHeadsObserver();

  const getClassName = (level) => {
    switch (level) {
      case 1:
        return "head1";
      case 2:
        return "head2";
      case 3:
        return "head3";
      case 4:
        return "head4";
      case 5:
        return "head5";
      default:
        return null;
    }
  };

  useEffect(() => {
    const elements = Array.from(
      document.querySelectorAll("h1, h2, h3, h4, h5"),
    ).map((elem) => {
      if (!elem.id) {
        elem.id = elem.innerText
          .toLowerCase()
          .replace(/\s+/g, "-")
          .replace(/[^\w-]/g, "");
      }
      return {
        id: elem.id,
        text: elem.innerText,
        level: Number(elem.nodeName.charAt(1)),
      };
    });
    setHeadings(elements);
  }, [pageID]);

  return (
    <nav className="table-of-content" aria-label="Table of contents">
      <button
        className="navbar-toggler blue d-block "
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNavAltMarkup"
        aria-controls="navbarNavAltMarkup"
        aria-expanded="false"
        aria-label="Toggle table of contents menu"
        tabIndex="0"
      >
        <svg
          className="toc-arrow ms-2"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          viewBox="0 0 16 16"
        >
          <path
            fillRule="evenodd"
            d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
          />
        </svg>
        <span className="ms-2">On this Page</span>
      </button>

      <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
        <ul className="tof-card" style={{ listStyle: "none", padding: 0 }}>
          
          <h2
            style={{ fontSize: "22px", marginBottom: "15px" }}
            id="toc-header"
          >
            On this Page
          </h2>
          {headings.map((heading) => (
            <li key={heading.id} className={getClassName(heading.level)}>
              <HashLink
                to={`#${heading.id}`}
                aria-current={activeId === heading.id ? "location" : undefined}
                style={{
                  color: activeId === heading.id ? "#08774b" : "#0065b8",
                  fontWeight: "bold",
                  display: "block",
                  padding: "8px 0",
                  paddingLeft: "14px",
                  borderBottom: "1px dotted #0065b8",
                }}
                scroll={(e) => e.scrollIntoView({ behavior: "smooth" })}
              >
                {heading.text}
              </HashLink>
            </li>
          ))}
          <RelatedLink pageID={pageID} />
        </ul>
      </div>
    </nav>
  );
}

export default TableOfContent;
